import { cloneDeep } from "lodash-es";
import { IVersionControl } from "../../interfaces/collection/ICollection";
import { addCollectionIdToEntity } from "./addCollectionIdToEntity";
export function getFormDataSchema() {
  var _this$options$sourceC;
  const entitySchema = cloneDeep(this.getEntitySchema());
  const collectionId = (_this$options$sourceC = this.options.sourceConfig) === null || _this$options$sourceC === void 0 ? void 0 : _this$options$sourceC.collectionId;
  if (collectionId) {
    addCollectionIdToEntity(collectionId, entitySchema);
  }
  const formDataSchema = {
    type: 'object',
    ...entitySchema,
    id: 'formData',
    title: '表单数据'
  };
  return formDataSchema;
}
export function getPublishStatus() {
  const formDataSchema = {
    type: 'number',
    id: 'publishStatus',
    title: '发布状态',
    default: 2 // 未发布
  };

  return formDataSchema;
}
export function getHistoryListDataSchema() {
  if (this.collection.collectionData.versionControl === IVersionControl.Row) {
    const historypListDataSchema = {
      id: 'historyListData',
      type: 'array',
      title: '历史版本',
      items: {
        type: 'object',
        fields: [{
          type: 'string',
          title: 'id',
          id: 'versionId'
        }, {
          type: 'string',
          title: '创建人',
          id: 'operator'
        }, {
          type: 'string',
          title: '版本描述',
          id: 'desc'
        }, {
          type: 'string',
          title: '版本数据',
          id: 'data'
        }, {
          type: 'number',
          title: '状态',
          id: '_rv_status'
        }, {
          type: 'string',
          title: '创建时间',
          id: '_ctime'
        }]
      }
    };
    return historypListDataSchema;
  }
  return null;
}
//# sourceMappingURL=form.js.map
